export default __webpack_public_path__ + "static/materialbox-b8784583a33380ba8577c13a10d4d0cb.png";